module.exports = __webpack_public_path__ + "static/media/2.e2a07b61.jpg";